/* global navigator */
var navigator = window.navigator || {};
export var isIEorEdge = function isIEorEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigator.userAgent;

  if (userAgent) {
    return /rv:11.0/i.test(userAgent) || /Edge\/\d./i.test(userAgent);
  }

  return false;
};
export var convertDegreesToRadians = function convertDegreesToRadians(degrees) {
  if (typeof degrees !== 'undefined') {
    return degrees * Math.PI / 180;
  }

  return degrees;
};